/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status__PaidInputs */

const en_payment_status__paid = /** @type {(inputs: Payment_Status__PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Payment_Status__PaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const payment_status__paid = /** @type {((inputs?: Payment_Status__PaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status__PaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_payment_status__paid(inputs)
});